import { withInstall } from '@lit-element/utils'
import Video from './src/video.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtVideo: SFCWithInstall<typeof Video> = withInstall(Video)
export default LtVideo

export * from './src/video'
